export const baseGridSx = {
  border: '1px solid rgba(0,0,0,0.1)',
  borderRadius: '8px',
  overflow: 'hidden',
  backgroundColor: '#FFFFFF',
  '& .MuiDataGrid-root': {
    border: 'none',
  },
  '& .MuiDataGrid-columnHeaders': {
    backgroundColor: '#FFFFFF',
    minHeight: '48px !important',
    maxHeight: '48px !important',
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
  },
  '& .MuiDataGrid-columnHeader': {
    padding: '0 16px',
    '&:not(:last-child)': {
      borderRight: '1px solid #E0E0E0 !important',
    },
  },
  '& .MuiDataGrid-columnHeaderTitleContainer': {
    padding: 0,
    overflow: 'visible',
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    fontFamily: 'Poppins, sans-serif',
    fontWeight: 500,
    fontSize: '14px',
    letterSpacing: '0.15px',
    color: '#4A4A4A',
    whiteSpace: 'nowrap',
    overflow: 'visible',
    textOverflow: 'unset',
  },
  '& .MuiDataGrid-row': {
    backgroundColor: '#FFFFFF',
    '&:hover': {
      backgroundColor: '#FFFFFF',
    },
  },
  '& .MuiDataGrid-cell': {
    padding: '0 16px',
    borderBottom: '1px solid rgba(0,0,0,0.1)',
    fontFamily: 'Poppins, sans-serif',
    fontWeight: 400,
    fontSize: '14px',
    letterSpacing: '0.15px',
    display: 'flex',
    alignItems: 'center',
    '&:not(:last-child)': {
      borderRight: '1px solid rgba(0,0,0,0.1)',
    },
  },
  '& .MuiDataGrid-row:last-child .MuiDataGrid-cell': {
    borderBottom: 'none',
  },
  '& .MuiDataGrid-columnSeparator': {
    display: 'none',
  },
  '& .MuiDataGrid-menuIcon': {
    display: 'none',
  },
  '& .MuiDataGrid-footerContainer': {
    display: 'none',
  },
  '& .MuiDataGrid-virtualScroller': {
    overflow: 'hidden',
    borderTop: '1px solid rgba(0,0,0,0.1)',
  },
  // Suppress cell focus outline
  '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
    outline: 'none',
  },
  '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
    outline: 'none',
  },
}
